"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- POPUPMESSAGE : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'PopupMessage',
  group: _definitionhelpers.groupNames.messages,
  props: {
    type: {
      type: 'string',
      default: 'verify'
    },
    title: {
      type: 'string',
      default: 'PopupMessage'
    },
    body: {
      type: 'object',
      default: _react.default.createElement("p", null, _react.default.createElement("span", null, "This is an example of a "), _react.default.createElement("strong", null, "PopupMessage"))
    },
    buttonPrimary: {
      type: 'object',
      default: {
        text: 'Confirm',
        variant: 'action',
        action: function action() {
          return console.log("Confirmed");
        }
      }
    },
    buttonSecondary: {
      type: 'object',
      default: {
        text: 'Discard',
        variant: 'system',
        action: function action() {
          return console.log("Discarded");
        }
      }
    }
  }
};
exports.default = _default;